module.exports = __webpack_public_path__ + "static/media/datasheet_team_row1_image.b3a7abe1.png";